import { createContext } from 'react';
const RequestContext = /*#__PURE__*/createContext(null);
export default RequestContext;